import { useHistory } from "react-router";
import React, { useState } from "react";
import { Box, Breadcrumbs, SxProps, Theme, Typography, useTheme } from "@mui/material";
import AlertModel from "../components/investorOverview/common/AlertModel";

interface InitialProps {
    array: Array<{
        name: string
        path: string
        warning?: boolean
        state?: any,
        search?: string
        textSx?: SxProps<Theme>,
        isTextLowerCase?: boolean;
        handleClick?: () => void
    }>;
}

const BreadCrum = (props: InitialProps) => {
    const { array } = props
    const { palette, typography } = useTheme()
    const history = useHistory();
    const [open, setOpen] = useState(false)
    const [replacePath, setReplacePath] = useState({
        path: '',
        state: {},
        search: ''
    })

    const handleRouter = async (item: {
        name: string
        path: string
        warning?: boolean
        state?: any
        search?: string,
        handleClick?: () => void
    }) => {
        if (item?.handleClick && !item.warning) await item?.handleClick()

        if (item.warning) {
            setOpen(true)
            setReplacePath((pre: any) => ({
                path: item.path,
                state: item?.state || {},
                search: item?.search || ""
            }))
        } else {
            setOpen(false)
            history.replace({ pathname: item.path, state: item?.state || {}, search: item?.search || "" })
        }
    }


    const handleClose = () => {
        setOpen(false)
    }

    const handleConfirm = () => {
        const dummy = [...array].filter((item) => item.path === replacePath?.path)[0]

        dummy.handleClick && dummy.handleClick()

        setOpen(false)
        history.replace({ pathname: replacePath.path, state: replacePath?.state || {}, search: replacePath?.search || "" })
    }


    return (
        <>
            <Breadcrumbs
                aria-label="Breadcrumb"
                separator={
                    <Typography color={palette.primary[800]} aria-hidden="true">
                        /
                    </Typography>
                }
                sx={{ '& .MuiBreadcrumbs-ol': { flexWrap: 'wrap', gap: '5px' } }}
            >
                {array.map((item, index) => {
                    const isLast = index === array.length - 1;
                    return (
                        <Box
                            key={index}
                            component={isLast ? 'span' : 'button'} 
                            onClick={isLast ? undefined : () => handleRouter(item)}
                            // aria-current={isLast ? 'page' : undefined}
                            disabled={isLast}
                            sx={{
                                border: 'none',
                                background: 'transparent',
                                fontFamily: typography.fontFamily,
                                color: isLast ? palette.grey[800] : palette.primary[800],
                                fontSize: 14,
                                fontWeight: 500,
                                textWrap: 'wrap',
                                cursor: isLast ? 'not-allowed' : 'pointer',
                                whiteSpace: 'wrap',
                                maxWidth: 'fit-content',
                                width: '100%',
                                textTransform: 'capitalize',
                                padding: 0,
                                margin: 0,

                                ...(item?.textSx || {}),
                            }}
                        >
                            {(item?.isTextLowerCase ?? true) ? `${item?.name?.toLowerCase()}` : item?.name}
                        </Box>
                    );
                })}
            </Breadcrumbs>
            {open &&
                <AlertModel
                    {...{
                        handleClose,
                        handleConfirm,
                        confirmBtnText: 'Go Back Anyway',
                        open,
                        setOpen,
                        title: 'Data not saved, will be lost!',
                        desc: 'Going back will result in loss of your entered data. Are you sure you want to proceed?',
                    }}
                />
            }
        </>
    )
}

export default BreadCrum